import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { OrganizationSearchService } from '../../services/organization-search.service';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { catchError, concat, debounceTime, distinctUntilChanged, filter, map, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OrganizationDto } from 'lib';
import { FormatSearchTermPipePipe } from '../../pipes/format-search-term-pipe.pipe';

@Component({
    selector: 'mmoga-organization-search',
    standalone: true,
    imports: [NgSelectModule, FormsModule, ReactiveFormsModule, CommonModule, FormatSearchTermPipePipe],
    templateUrl: './organization-search.component.html',
    styleUrl: './organization-search.component.scss'
})
export class OrganizationSearchComponent implements OnInit {
    private organizationService = inject(OrganizationSearchService);

    placeholder = 'Search by Instance, Firm or FGI ';
    currentSearchTerm = '';
    minSearchTermLength = 3;
    organizationsLoading = false;
    morePages = false;
    organizationsSearchInput$ = new Subject<string>;
    organizations$: Observable<OrganizationDto[]> = new Observable<OrganizationDto[]>();

    @Input() readOnly = false;
    @Input() selectedOrganizations: OrganizationDto[] = new Array<OrganizationDto>();
    @Output() newOrganizationSelectedEvent = new EventEmitter<OrganizationDto>();
    @ViewChild('organizationsSelect') private organizationsSelect!: NgSelectComponent;

    ngOnInit(): void {
        this.loadOrganizations();
    }

    loadOrganizations(): void {
        this.organizations$ = concat(
            this.organizationsSearchInput$.pipe(
                filter(currentSearchTerm => {
                    return currentSearchTerm !== null && currentSearchTerm.length >= this.minSearchTermLength;
                }),
                distinctUntilChanged(),
                debounceTime(800),
                tap(() => this.organizationsLoading = true),
                switchMap(searchTerm => {
                    return this.organizationService.searchOrganizations(searchTerm, this.selectedOrganizations.map(({ id }) => id)).pipe(
                        map(organizationsResult => {
                            this.morePages = organizationsResult.totalElements > organizationsResult.size;
                            return organizationsResult.content;
                        }),
                        catchError(() => of([])), // empty list on error
                        tap(() => this.organizationsLoading = false)
                    );
                })
            )
        );
    }

    onOrganizationChange(event: OrganizationDto): void {
        if (event) {
            this.newOrganizationSelectedEvent.emit(event);
        }
        this.organizationsSelect.handleClearClick();
        this.resetCurrentSearch();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSearchTermChange(event: { term: string; items: any[] }): void {
        if (!event.term) {
            this.resetCurrentSearch();
            return;
        }
        if (this.currentSearchTerm !== event.term) {
            this.currentSearchTerm = event.term;
        }
    }

    resetCurrentSearch(): void {
        this.loadOrganizations();
        this.morePages = false;
    }
}
